import Api from "../../utils/api";
import Endpoints from "../../core/config/Endpoints";

export class UserService {
    async add(data) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.post(Endpoints.user, data, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }

    async get(id) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.get(`${Endpoints.user}/${id}`, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }

    async update(id, data) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.patch(`${Endpoints.user}/${id}`, data, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }

    async sendCredentials(id) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.get(`${Endpoints.sendCredentials}/${id}`, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }
}
